<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
<style>
@import url('https://fonts.googleapis.com/css2?family=Assistant:wght@400;700&display=swap');
</style>
<script setup lang="ts"></script>
